module.exports = __webpack_public_path__ + "static/media/freqsho-admin-logo.a3029377.png";